import PropTypes from 'prop-types';

const accountShape = PropTypes.shape({
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  amlFraud: PropTypes.bool,
  balance: PropTypes.number,
  birthDate: PropTypes.number,
  btag: PropTypes.string,
  city: PropTypes.string,
  clientActivityState: PropTypes.string,
  clientVerificationState: PropTypes.string,
  country: PropTypes.string,
  currency: PropTypes.string,
  docNumber: PropTypes.string,
  docSeries: PropTypes.string,
  docType: PropTypes.string,
  docVerified: PropTypes.bool,
  dormant: PropTypes.bool,
  email: PropTypes.string,
  emailVerificationRequested: PropTypes.bool,
  emailVerified: PropTypes.bool,
  fingerprint: PropTypes.string,
  firstName: PropTypes.string,
  gender: PropTypes.string,
  id: PropTypes.number,
  language: PropTypes.string,
  lastLoginCountry: PropTypes.string,
  lastLoginDate: PropTypes.number,
  lastLoginIp: PropTypes.string,
  lastName: PropTypes.string,
  login: PropTypes.string,
  middleName: PropTypes.string,
  partnerId: PropTypes.number,
  pep: PropTypes.bool,
  permanentlySE: PropTypes.bool,
  phone: PropTypes.string,
  phoneVerificationRequested: PropTypes.bool,
  phoneVerified: PropTypes.bool,
  projectId: PropTypes.number,
  referer: PropTypes.string,
  region: PropTypes.string,
  registrationCountry: PropTypes.string,
  registrationDate: PropTypes.number,
  registrationIp: PropTypes.string,
  selfExcludedDueDate: PropTypes.string,
  status: PropTypes.string,
  stolen: PropTypes.bool,
  street: PropTypes.string,
  suspended: PropTypes.bool,
  temporarySE: PropTypes.bool,
  testAccount: PropTypes.bool,
  timeZone: PropTypes.string,
  title: PropTypes.string,
  underage: PropTypes.bool,
  userAgent: PropTypes.string,
  utmMarkings: PropTypes.string,
  zip: PropTypes.string,
});

export default accountShape;
